import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import SnackbarProvider from "./redux/snackbarProvider";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./microsoftAuthConfig";
import { MsalProvider } from "@azure/msal-react";
import { AbilityContext } from "./casl/AbilityContext";
import ability from "./casl/Can";
import "keen-slider/keen-slider.min.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <AbilityContext.Provider value={ability}>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </AbilityContext.Provider>
    </Provider>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
